import { useState, useEffect } from 'react'

export type Screen = 'home' | 'program' | 'learn' | 'tools' | 'tracker'

export function useAppState() {
  const [activeScreen, setActiveScreen] = useState<Screen>('home')
  const [splashVisible, setSplashVisible] = useState(true)
  const [splashRendered, setSplashRendered] = useState(true)
  const [tasks, setTasks] = useState([false, false, false, false, false])
  const [symptoms, setSymptoms] = useState<Record<string, number>>({
    bloat: 0,
    energy: 0,
    puff: 0,
    brain: 0,
    skin: 0,
    sleep: 0,
  })
  const [activeModal, setActiveModal] = useState<string | null>(null)
  const [activeChapter, setActiveChapter] = useState<string | null>(null)
  const [toast, setToast] = useState<string | null>(null)

  useEffect(() => {
    const timer1 = setTimeout(() => setSplashVisible(false), 4500)
    const timer2 = setTimeout(() => setSplashRendered(false), 5300)
    return () => {
      clearTimeout(timer1)
      clearTimeout(timer2)
    }
  }, [])

  const toggleTask = (index: number) => {
    const newTasks = [...tasks]
    newTasks[index] = !newTasks[index]
    setTasks(newTasks)
    if (newTasks[index]) showToast('Task completed!')
  }

  const setSymptom = (key: string, value: number) => {
    setSymptoms((prev) => ({ ...prev, [key]: value }))
    showToast(`Logged ${key}: ${value}/5`)
  }

  const showToast = (msg: string) => {
    setToast(msg)
    setTimeout(() => setToast(null), 2500)
  }

  return {
    activeScreen,
    setActiveScreen,
    splashVisible,
    splashRendered,
    tasks,
    toggleTask,
    symptoms,
    setSymptom,
    activeModal,
    setActiveModal,
    activeChapter,
    setActiveChapter,
    toast,
    showToast,
  }
}
